export const createObjectClone = (object: any) =>
  JSON.parse(JSON.stringify(object));
